import type { PredictRequest, PredictResponse, TrendsResponse } from '../types';

const API_BASE: string = (import.meta.env.VITE_API_BASE as string | undefined) ?? '';

export class ApiError extends Error {
  status: number;
  body: unknown;
  constructor(status: number, body: unknown, message: string) {
    super(message);
    this.status = status;
    this.body = body;
  }
}

export async function predict(req: PredictRequest): Promise<PredictResponse> {
  const url = (API_BASE.replace(/\/+$/, '') || '') + '/predict';
  const r = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(req),
  });
  const json = await r.json().catch(() => ({}));
  if (!r.ok) {
    const detail = (json as { detail?: { error?: string } })?.detail?.error ?? r.statusText;
    throw new ApiError(r.status, json, detail);
  }
  return json as PredictResponse;
}

export async function getTrends(
  municipalityCode: string,
  propertyType: 'condo' | 'house',
): Promise<TrendsResponse> {
  const base = API_BASE.replace(/\/+$/, '') || '';
  const url = `${base}/trends?municipality_code=${encodeURIComponent(municipalityCode)}&property_type=${propertyType}`;
  const r = await fetch(url);
  const json = await r.json().catch(() => ({}));
  if (!r.ok) {
    const detail = (json as { detail?: { error?: string } })?.detail?.error ?? r.statusText;
    throw new ApiError(r.status, json, detail);
  }
  return json as TrendsResponse;
}
